import React, { useState } from 'react';
import AdminEvents from '../components/admin/AdminEvents';
import AdminResults from '../components/admin/AdminResults';
import AdminGallery from '../components/admin/AdminGallery';
import AdminStudents from '../components/admin/AdminStudents';
import api from '../services/api';
import './Admin.css';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('events');
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  // Login Handle
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/auth/admin/login', { username, password });
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        setIsAuthenticated(true);
        setLoginError('');
      }
    } catch (error) {
      setLoginError(error.response?.data?.message || 'Login failed');
    }
  };

  const renderTabContent = () => {
    switch(activeTab) {
      case 'events':
        return <AdminEvents />;
      case 'results':
        return <AdminResults />;
      case 'gallery':
        return <AdminGallery />;
      case 'students':
        return <AdminStudents />;
      default:
        return <AdminEvents />;
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-page login-container">
        <div className="container" style={{ maxWidth: '400px', margin: '4rem auto' }}>
          <h1 className="page-title">ADMIN LOGIN</h1>
          <div className="card" style={{ padding: '2rem' }}>
            {loginError && <p style={{ color: 'var(--primary-red)', marginBottom: '1rem', textAlign: 'center' }}>{loginError}</p>}
            <form onSubmit={handleLogin}>
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label>Username</label>
                <input 
                  type="text" 
                  value={username} 
                  onChange={(e) => setUsername(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem', borderRadius: '4px', border: '1px solid #ccc', color: '#000' }}
                  required
                />
              </div>
              <div className="form-group" style={{ marginBottom: '2rem' }}>
                <label>Password</label>
                <input 
                  type="password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem', borderRadius: '4px', border: '1px solid #ccc', color: '#000' }}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Login</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h1 className="page-title" style={{ margin: 0 }}>ADMIN PANEL</h1>
          <button onClick={handleLogout} className="btn" style={{ background: 'transparent', border: '1px solid var(--primary-red)', color: 'var(--primary-red)' }}>Logout</button>
        </div>
        
        <div className="admin-tabs">
          <button 
            className={`tab-btn ${activeTab === 'events' ? 'active' : ''}`}
            onClick={() => setActiveTab('events')}
          >
            Events
          </button>
          <button 
            className={`tab-btn ${activeTab === 'results' ? 'active' : ''}`}
            onClick={() => setActiveTab('results')}
          >
            Results
          </button>
          <button 
            className={`tab-btn ${activeTab === 'gallery' ? 'active' : ''}`}
            onClick={() => setActiveTab('gallery')}
          >
            Gallery
          </button>
          <button 
            className={`tab-btn ${activeTab === 'students' ? 'active' : ''}`}
            onClick={() => setActiveTab('students')}
          >
            Students
          </button>
        </div>
        
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Admin;